import PropTypes from 'prop-types';
import React, { memo } from 'react';
import './styles.scss';

const VariablePreview = memo(({ variables, examples }) => {
  if (!variables || variables.length === 0) return null;

  return (
    <div className="wa-variable-preview">
      <div className="card border-0 mt-3">
        <div className="card-header bg-light border-0">
          <h6 className="mb-0">Variable Examples</h6>
        </div>
        <div className="card-body">
          <div className="variable-list">
            {variables.map((variable, index) => (
              <div key={index} className="variable-item">
                <div className="variable-name">{variable}</div>
                <div className="variable-example">
                  {examples[index] || <span className="text-muted">No example provided</span>}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
});

VariablePreview.propTypes = {
  variables: PropTypes.arrayOf(PropTypes.string),
  examples: PropTypes.arrayOf(PropTypes.string),
};

VariablePreview.displayName = 'VariablePreview';

export default VariablePreview;
